import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginPage from './features/auth/LoginPage';
import ProtectedRoute from './features/auth/ProtectedRoute';
import SessionGuard from './features/auth/SessionGuard';
import AppShell from './components/layout/AppShell';
import DoctorShell from './components/layout/DoctorShell';
import DashboardPage from './features/dashboard/DashboardPage';
import LeadsPage from './features/leads/LeadsPage';
import LeadsKanbanPage from './features/leads/LeadsKanbanPage';
import PatientsPage from './features/patients/PatientsPage';
import ConsultationsPage from './features/consultations/ConsultationsPage';
import SessionsPage from './features/sessions/SessionsPage';
import SettingsPage from './features/settings/SettingsPage';
import AppointmentsPage from './features/appointments/AppointmentsPage';
import BillingPage from './features/billing/BillingPage';
import CommunicationsPage from './features/communications/CommunicationsPage';
import CampaignsPage from './features/campaigns/CampaignsPage';
import WhatsAppPage from './features/whatsapp/WhatsAppPage';
import ReportsPage from './features/reports/ReportsPage';
import StaffPage from './features/staff/StaffPage';
import CallLogsPage from './features/callLogs/CallLogsPage';
import TaskBoardPage from './features/tasks/TaskBoardPage';

// Redirect Doctors away from the full CRM shell to their calendar-only view.
function NonDoctorRoute({ children }) {
  const roles = useSelector((s) => s.auth?.user?.roles ?? []);
  const isDoctor = roles.includes('Doctor') && !roles.includes('Admin');
  return isDoctor ? <Navigate to="/doctor/appointments" replace /> : children;
}

export default function App() {
  return (
    <>
      <SessionGuard />
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        {/* ── Doctor: calendar-only restricted interface ── */}
        <Route element={<ProtectedRoute roles={['Doctor']}><DoctorShell /></ProtectedRoute>}>
          <Route path="doctor/appointments" element={<AppointmentsPage />} />
        </Route>

        {/* ── All other staff: full CRM shell ── */}
        <Route element={<ProtectedRoute><NonDoctorRoute><AppShell /></NonDoctorRoute></ProtectedRoute>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="tasks" element={<TaskBoardPage />} />
          <Route path="call-logs" element={<CallLogsPage />} />
          <Route path="leads" element={<LeadsPage />} />
          <Route path="leads/kanban" element={<LeadsKanbanPage />} />
          <Route path="consultations" element={<ConsultationsPage />} />
          <Route path="patients" element={<PatientsPage />} />
          <Route path="appointments" element={<AppointmentsPage />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="communications" element={<CommunicationsPage />} />
          <Route path="campaigns" element={<CampaignsPage />} />
          <Route path="whatsapp" element={<WhatsAppPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="staff" element={<StaffPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
